export interface ZebraPDAPlugin {
  // 初始化UHF模块
  initRFID(): Promise<{ isSuccess: boolean }>;
  openReader(): Promise<{ isSuccess: boolean }>;
  closeReader(): Promise<{ isSuccess: boolean }>;
  disconnect(): Promise<{ isSuccess: boolean }>;
  disposeReaders(): Promise<{ isSuccess: boolean }>;
}
